import { combineReducers, Reducer } from 'redux';
import { reducer as coreAssortmentReducer } from 'b2b-apps/shop/product/redux/coreAssortment/reducer';
import { reducer as productAccessoriesReducer } from 'b2b-apps/shop/product/redux/productAccessories/reducer';
import { reducer as productGalleryReducer } from 'b2b-apps/shop/product/redux/productGallery/reducer';
import { reducer as productPdfReducer } from 'b2b-apps/shop/product/redux/productPdf/reducer';
import { reducer as productReportErrorReducer } from 'b2b-apps/shop/product/redux/productReportError/reducer';
import { reducer as productsReducer } from 'b2b-apps/shop/product/redux/products/reducer';
import { reducer as productsCompareReducer } from 'b2b-apps/shop/product/redux/productsCompare/reducer';
import { reducer as productVariantsMatrixReducer } from 'b2b-apps/shop/product/redux/productVariantsMatrix/reducer';
import { ProductActions, ProductState } from './types';

const reducer: Reducer<ProductState, ProductActions> = combineReducers({
  productAccessories: productAccessoriesReducer,
  productGallery: productGalleryReducer,
  products: productsReducer,
  productsCompare: productsCompareReducer,
  productVariantsMatrix: productVariantsMatrixReducer,
  productPdf: productPdfReducer,
  productReportError: productReportErrorReducer,
  coreAssortment: coreAssortmentReducer,
});

export { reducer };
